import get from 'lodash-es/get';
import defaultTo from 'lodash-es/defaultTo';
import { noWechatPayDomain } from '../config/domain';

export default class Utils {
  /**
   * 根据 object对象的path路径获取值
   */
  static get(obj, path, defaultValue) {
    return defaultTo(get(obj, path), defaultValue);
  }

  /**
   * 将rpx转换为px
   */
  static rpx2px(rpx) {
    const systemInfo = uni.getSystemInfoSync();
    const screenWidth = systemInfo.safeArea.width;
    return (rpx / 750) * screenWidth;
  }

  // 将16进制颜色值变为rgb格式
  static hexToRgb(hex) {
    let r = 0,
      g = 0,
      b = 0;
    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
      r = parseInt(hex[1] + hex[2], 16);
      g = parseInt(hex[3] + hex[4], 16);
      b = parseInt(hex[5] + hex[6], 16);
    }
    return { r, g, b };
  }
  // 根据传入的url参数获取url上面指定参数的值
  static getQueryParamFromUrl(url, name) {
    const queryString = url.split('?')[1];
    if (!queryString) {
      return null;
    }
    const regex = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    const result = queryString.match(regex);
    return result ? decodeURIComponent(result[2]) : null;
  }

  static removeQueryParamFromUrl(url, name) {
    // 移除指定参数的正则表达式
    const regex = new RegExp(`([?&])${name}=.*?(&|$)`, 'i');
    const newUrl = url.replace(regex, (match, p1, p2) => {
      if (p2 === '&') {
        return p1;
      }
      return '';
    });

    // 移除多余的符号
    return newUrl.replace(/[?&]$/, '');
  }

  // 传入一个url，对url上?后面的所有参数的值进行encode编码，返回新的路径
  static encodeUrlParam(url) {
    const queryString = url.split('?')[1];
    if (!queryString) {
      return url;
    }
    const params = queryString.split('&');
    const newParams = [];
    params.forEach((param) => {
      const pair = param.split(/=(.+)/).slice(0, 2);
      if (pair[1]) {
        newParams.push(`${pair[0]}=${encodeURIComponent(pair[1])}`);
      }
    });
    return `${url.split('?')[0]}?${newParams.join('&')}`;
  }

  // 判断是不是个人微信
  static isPersonalWechat() {
    if (navigator && navigator.userAgent) {
      const userAgent = navigator.userAgent.toLowerCase();
      const isWechat = /micromessenger\/([\d.]+)/i.test(userAgent);
      const isWorkWechat = /wxwork\/([\d.]+)/i.test(userAgent);
      return isWechat && !isWorkWechat;
    } else {
      return false;
    }
  }

  // 判断能否使用微信内支付
  static canUseWechatPay() {
    if (window && window.location && window.location.origin) {
      return !noWechatPayDomain.includes(window.location.origin);
    } else {
      return false;
    }
  }
}
